import { EMilliSeconds } from 'modules/common/constants/const';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAuth } from 'modules/auth/hooks/useAuth';

import { useFetchMyBundlesStatusQuery } from '../actions/fetchMyBundlesStatus';

export interface MyBundlesStatusParams {
  skipFetching?: boolean;
}

export const useMyBundlesStatus = ({
  skipFetching = false,
}: MyBundlesStatusParams | void = {}) => {
  const { group } = useAccount();
  const { isLoggedIn } = useAuth();

  return useFetchMyBundlesStatusQuery(
    { group },
    {
      skip: !isLoggedIn || skipFetching,
      pollingInterval: 30 * EMilliSeconds.Second,
    },
  );
};
